import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7240c450")

_pushScopeId("data-v-7240c450")
const _hoisted_1 = { class: "px-16" }
const _hoisted_2 = { class: "mt-8 mb-24 d-f" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "d-f f-sm mb-16" }
const _hoisted_5 = { class: "mr-20" }
const _hoisted_6 = { class: "f-400 mb-4 f-md" }
const _hoisted_7 = { class: "mr-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("pts")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Prize pool")
const _hoisted_10 = { class: "mr-20" }
const _hoisted_11 = { class: "f-400 mb-4 f-md" }
const _hoisted_12 = { class: "mr-4" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("pts")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Entry fee")
const _hoisted_15 = { class: "f-400 mb-4 f-md" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Participants")
const _hoisted_17 = { class: "d-f f-sm mb-16" }
const _hoisted_18 = { class: "mr-20" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Kick-off")
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "f-400 mb-4 f-md" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Duration")
const _hoisted_23 = {
  key: 0,
  class: "df-middle t-center c-white f-sm"
}
const _hoisted_24 = { class: "time" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("days")
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "time-divider" }, null, -1)
const _hoisted_27 = { class: "time" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "time-divider" }, ":", -1)
const _hoisted_29 = { class: "time" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "time-divider" }, ":", -1)
const _hoisted_31 = { class: "time" }
const _hoisted_32 = {
  class: "f-md f-400",
  style: {"line-height":"18px"}
}
const _hoisted_33 = {
  key: 0,
  class: "mt-24 btn f-lg f-bold",
  style: {"width":"100%"}
}
const _hoisted_34 = {
  key: 1,
  class: "mt-24 btn f-lg f-bold",
  style: {"width":"100%"}
}
const _hoisted_35 = { class: "py-32" }
const _hoisted_36 = /*#__PURE__*/_createVNode("p", { class: "f-nm f-bold board-title" }, "Leaderboard", -1)
const _hoisted_37 = { class: "c-title f-sm df-middle df-between pl-24 title" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Memeber")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Profit%")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Prize")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_Time = _resolveComponent("Time")
  const _component_PrimeOnly = _resolveComponent("PrimeOnly")
  const _component_TheRankListItem = _resolveComponent("TheRankListItem")
  const _component_List = _resolveComponent("List")
  const _component_Holder = _resolveComponent("Holder")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.detail.name || 'detail'), 1)
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Pic, {
            src: _ctx.detail.pic,
            class: "mr-24",
            width: "88",
            height: "88"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("p", _hoisted_6, [
                  _createVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.endPrize), 1),
                  _createVNode(_component_t, { path: "membership_13" }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_t, {
                  as: "p",
                  path: "tournamentdetail_2",
                  class: "c-title f-sm"
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("p", _hoisted_11, [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.detail.entryFee), 1),
                  _createVNode(_component_t, { path: "membership_13" }, {
                    default: _withId(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_t, {
                  as: "p",
                  path: "tournamentdetail_3",
                  class: "c-title f-sm"
                }, {
                  default: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", null, [
                _createVNode("p", _hoisted_15, _toDisplayString(_ctx.detail.participant), 1),
                _createVNode(_component_t, {
                  as: "p",
                  path: "tournamentdetail_4",
                  class: "c-title f-sm"
                }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_Time, {
                  tag: "p",
                  class: "f-400 mb-4 f-md",
                  style: {"white-space":"nowrap"},
                  format: 'MM-dd HH:mm',
                  time: _ctx.detail.startTime
                }, null, 8, ["time"]),
                _createVNode(_component_t, {
                  as: "p",
                  path: "tournamentdetail_5",
                  class: "c-title f-sm"
                }, {
                  default: _withId(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("p", _hoisted_21, [
                  _createVNode("span", null, _toDisplayString(_ctx.detail.duration), 1)
                ]),
                _createVNode(_component_t, {
                  as: "p",
                  path: "tournamentdetail_6",
                  class: "c-title f-sm"
                }, {
                  default: _withId(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.detail.status !== 2 && _ctx.detail.endTime > new Date().getTime())
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  (_ctx.days > 0)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("div", _hoisted_24, [
                          _createTextVNode(_toDisplayString(_ctx.days) + " ", 1),
                          _createVNode(_component_t, { path: "tournamentdetail_7" }, {
                            default: _withId(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_26
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_27, _toDisplayString(_ctx.zeroTime(_ctx.hours)), 1),
                  _hoisted_28,
                  _createVNode("div", _hoisted_29, _toDisplayString(_ctx.zeroTime(_ctx.minutes)), 1),
                  _hoisted_30,
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.zeroTime(_ctx.seconds)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("p", _hoisted_32, _toDisplayString(_ctx.detail.tips), 1),
        (_ctx.detail.status === 2 || _ctx.detail.endTime < new Date().getTime())
          ? (_openBlock(), _createBlock("button", _hoisted_33, [
              _createVNode(_component_t, {
                path: "tournamentdetail_19",
                custom: ""
              }, {
                default: _withId(({td}) => [
                  _createTextVNode(_toDisplayString(td || 'Closed'), 1)
                ]),
                _: 1
              })
            ]))
          : (_ctx.joinStatus === 1)
            ? (_openBlock(), _createBlock("button", _hoisted_34, [
                _createVNode(_component_t, {
                  path: "tournamentdetail_18",
                  custom: ""
                }, {
                  default: _withId(({td}) => [
                    _createTextVNode(_toDisplayString(td || 'Participated'), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(_component_PrimeOnly, {
                key: 2,
                class: [{primary: _ctx.detail.status === 1}, "mt-24 btn f-lg f-bold br-lg block"],
                tag: "button",
                text: "tournamentdetail_15",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.detail.status === 1 && _ctx.participate()))
              }, {
                default: _withId(() => [
                  _createVNode(_component_t, {
                    path: "tournamentdetail_8",
                    custom: ""
                  }, {
                    default: _withId(({td}) => [
                      _createTextVNode(_toDisplayString(td || 'Participate'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"])),
        _createVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode("div", _hoisted_37, [
            _createVNode(_component_t, {
              as: "p",
              path: "tournamentdetail_9",
              class: "flex-2"
            }, {
              default: _withId(() => [
                _hoisted_38
              ]),
              _: 1
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "tournamentdetail_10",
              class: "flex-1 t-center"
            }, {
              default: _withId(() => [
                _hoisted_39
              ]),
              _: 1
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "tournamentdetail_11",
              class: "flex-1 t-right"
            }, {
              default: _withId(() => [
                _hoisted_40
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Holder, { content: _ctx.rankList }, {
            default: _withId(() => [
              _createVNode(_component_List, { "list-data": _ctx.rankList }, {
                default: _withId(({ item }) => [
                  _createVNode(_component_TheRankListItem, {
                    list: item,
                    participate: _ctx.joinStatus === 1
                  }, null, 8, ["list", "participate"])
                ]),
                _: 1
              }, 8, ["list-data"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _: 1
  }))
})